import React, { FC, useEffect, useMemo, useRef, useState } from 'react'
import { hot } from 'react-hot-loader/root'
import { observer } from 'mobx-react'
import { Progress } from 'antd'
import { PoweroffOutlined } from '@ant-design/icons'
import { DWActivityParticipated, JsqProductHS } from 'src/commons/store/UserStore'
import bgImg from 'src/pc/assets/images/speedBall/bg.png'
import styled from 'styled-components'
import rocket from 'src/pc/assets/images/speedBall/rocket.png'
import classNames from 'classnames'
import useRunDefaultSpeed from '../components/hooks/useRunDefaultSpeed'
import activityTagImg from 'src/pc/assets/images/speedBall/activity-tag.png'
import success from 'src/pc/assets/images/speedBall/success.png'
import { BeijingTime, sendMessageToMainClient } from 'src/commons/utils'
import { getActivityConfigInfoHS } from 'src/commons/store/GameStore'
import moment from 'moment'
import { autorun, IReactionDisposer } from 'mobx'
import SpeedBallStore from 'src/pc/store/SpeedBallStore'

//加速球点击赠送加速器时长活动编号
const activityNo = 'AT5626340350535583404'
let timer: NodeJS.Timeout
const Home: FC = () => {
  const [giftVisible, setGiftVisible] = useState<boolean>(false)
  const [contextMenuVisible, setContextMenuVisible] = useState(false)
  const [speedTimeSuccess, setSpeedTimeSuccess] = useState(false)
  const { isDownloading, isStarting, downloadPercent } = useRunDefaultSpeed(true)
  const isProgressing = isDownloading || isStarting
  const activityConfigInfo = getActivityConfigInfoHS.SuccessResult

  const memberDuration = useMemo(() => {
    return activityConfigInfo?.activityState === 1 ? Number(activityConfigInfo?.activityConfig?.memberDuration ?? 0) : 0
  }, [activityConfigInfo])

  //是否在活动时间内
  const isInActTime = useMemo(() => {
    if (!activityConfigInfo) {
      return false
    }
    return moment(BeijingTime.now()).isBetween(
      moment(activityConfigInfo?.beginTime),
      moment(activityConfigInfo?.endTime),
    )
  }, [activityConfigInfo])

  const run = () => {
    setContextMenuVisible(false)
    if (isProgressing) {
      return
    }
    sendMessageToMainClient('runSpeedClient')
    sendMessageToMainClient('sensorsReport', { eventName: 'BoxClient_speedball_click' })
    // runSpeedClient(defaultSpeed)
  }

  const onContextMenu = (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    event.preventDefault()
    setContextMenuVisible(true)
  }

  const onClose = () => {
    sendMessageToMainClient('sensorsReport', { eventName: 'BoxClient_speedball_signout' })
    window.FuluApp?.JSNotifyCppFunc('show_speed_ball', 0, 0)
    setContextMenuVisible(false)
  }
  const delayTimer = useRef<NodeJS.Timeout>()
  const onMouseEnter = () => {
    delayTimer.current && clearTimeout(delayTimer.current)
  }
  const onMouseLeave = () => {
    delayTimer.current = setTimeout(() => {
      setContextMenuVisible(false)
    }, 300)
  }

  const onGetSpeedTime = async () => {
    try {
      const got = await DWActivityParticipated.Execute({ activityNo })
      if (got) {
        sendMessageToMainClient('showMessage', { type: 'warn', message: '每位用户只能领取一次时长哦~' })
        setGiftVisible(false)
        return
      }
    } catch (e) {
      console.log('err', e)
    }

    sendMessageToMainClient('getSpeedTime', { activityNo, time: memberDuration })
    sendMessageToMainClient('sensorsReport', { name: 'BoxClient_speedball_click' })
    // setGiftVisibleTemp(false)
    setSpeedTimeSuccess(true)
    timer && clearTimeout(timer)
    timer = setTimeout(() => {
      setSpeedTimeSuccess(false)
    }, 2000)
  }

  const disposerRef = useRef<IReactionDisposer>()
  const listenMsg = () => {
    disposerRef.current = autorun(() => {
      const msg = SpeedBallStore.client2speedMsg?.msg
      if (!msg) {
        return
      }
      let json: { __type__: string; [p: string]: any } = { __type__: '' }
      try {
        json = JSON.parse(msg)
      } catch (e) {
        console.log('e', e)
        return
      }
      const { __type__: type } = json
      switch (type) {
        case 'loginSuccess':
          localStorage.setItem('php-token', json.token)
          SpeedBallStore.token = json.token
          break
        case 'clearToken':
          localStorage.removeItem('php-token')
          SpeedBallStore.token = ''
          break
        default:
          console.log('未处理的消息', json)
      }
    })
  }

  useEffect(() => {
    listenMsg()
    JsqProductHS.Execute()
    getActivityConfigInfoHS.Execute({ activityNo })
    return () => {
      disposerRef.current?.()
    }
  }, [])

  useEffect(() => {
    if (!SpeedBallStore.token) {
      setGiftVisible(false)
      return
    }
    DWActivityParticipated.Execute({
      activityNo,
    })
      .then(res => {
        setGiftVisible(!res)
      })
      .catch(() => {
        setGiftVisible(true)
      })
  }, [SpeedBallStore.token])

  return (
    <StyledHome onMouseLeave={onMouseLeave} onMouseEnter={onMouseEnter}>
      <StyledSpeedBall onContextMenu={onContextMenu}>
        <div className="circle" />
        {!isDownloading && !speedTimeSuccess && (
          <div className="normal" onClick={run}>
            <div className="sky">
              <div className="line line-type-1 line-1" />
              <div className="line line-type-1 line-2" />
              <div className="line line-type-2 line-3" />
              <div className="line line-type-2 line-4" />
              <div className="line line-type-1 line-5" />
              <div className="line line-type-1 line-6" />
              <div className="line line-type-2 line-7" />
              <div className="line line-type-2 line-8" />
              <div className="rocket">
                <img src={rocket} alt="" draggable={false} />
              </div>
            </div>
            {/*<div className="btn">一键加速</div>*/}
          </div>
        )}
        {isProgressing && (
          <>
            <div className={classNames('progress', { loading: isStarting })}>
              <Progress
                type="circle"
                percent={isStarting ? 33 : downloadPercent}
                width={66}
                strokeColor={'#FFBF28'}
                trailColor={'transparent'}
                strokeWidth={3}
                format={(percent, successPercent) => {
                  return (
                    <div className={'percent'}>{isDownloading && <span className="down-title">{percent}%</span>}</div>
                  )
                }}
              />
            </div>
          </>
        )}
        {speedTimeSuccess && (
          <div className="speed-time-success">
            <main>
              <img src={success} alt="" />
            </main>
          </div>
        )}
        <img style={{ display: 'none' }} src={success} alt="" />
        {
          <div className="status-text">
            {speedTimeSuccess ? '领取成功' : isProgressing ? (isDownloading ? '正在下载' : '启动中') : '游戏加速'}
          </div>
        }

        {giftVisible && !!memberDuration && isInActTime && (
          <StyledActivityTagBox onClick={onGetSpeedTime}>
            {/*<img*/}
            {/*  className="cancel"*/}
            {/*  draggable={false}*/}
            {/*  src={cancelIcon}*/}
            {/*  onClick={e => {*/}
            {/*    e.stopPropagation()*/}
            {/*    handleHiddenCancel()*/}
            {/*  }}*/}
            {/*/>*/}
            <strong>{memberDuration}小时</strong>加速器时长
          </StyledActivityTagBox>
        )}
      </StyledSpeedBall>
      {contextMenuVisible && (
        <StyledContextMenu onClick={onClose}>
          <PoweroffOutlined />
          <span>本次退出</span>
        </StyledContextMenu>
      )}
    </StyledHome>
  )
}

const StyledActivityTagBox = styled.div`
  width: 105px;
  height: 45px;
  text-align: center;
  line-height: 1;
  padding-top: 29px;
  position: absolute;
  top: -4px;
  left: 50%;
  transform: translate(-50%, -100%);
  background: url('${activityTagImg}');
  font-weight: bold;
  color: rgb(166, 102, 40);
  font-size: 12px;

  strong {
    color: #fff;
  }

  .cancel {
    position: absolute;
    top: 0;
    right: 10px;
    width: 10px;
    height: 10px;
  }
`

const StyledContextMenu = styled.div`
  //-webkit-app-region: no-drag;
  cursor: pointer;
  width: 80px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  background: rgba(0, 0, 0, 0.5);
  font-size: 12px;
  color: #fff;
  margin: 60px auto 0 auto;
  backdrop-filter: blur(10px);

  span {
    margin-left: 4px;
  }

  .anticon-poweroff {
    margin-top: 2px;
  }
`

const StyledSpeedBall = styled.div`
  width: 66px;
  height: 66px;
  //background: #232323;
  /* border: 2px solid #373737; */
  border-radius: 50%;
  cursor: pointer;
  margin: 0 auto;
  position: relative;
  --inner-width: 66px;
  --inner-height: 66px;
  top: 54px;
  /* transform: scale(0.8); */

  .status-text {
    padding: 0 4px;
    height: 18px;
    line-height: 16px;
    background: #271c0b;
    border-radius: 10px;
    border: 1px solid #504122;
    font-weight: bold;
    color: #ffbf28;
    font-size: 12px;
    white-space: nowrap;
    text-align: center;
    position: absolute;
    bottom: -2px;
    left: 50%;
    transform: translateX(-50%);
  }

  .speed-time-success {
    width: 24px;
    height: 19px;
    position: absolute;
    left: 22px;
    top: 23px;

    img {
      display: block;
    }

    main {
      width: 0;
      overflow: hidden;
      animation: move 0.2s ease-in forwards;
    }

    @keyframes move {
      0% {
        width: 0;
      }
      100% {
        width: 24px;
      }
    }
  }

  .circle {
    background: url(${bgImg}) no-repeat;
    width: var(--inner-width);
    height: var(--inner-height);
    /* background: #232323; */
    /* box-shadow: inset 0px 0px 6px 0px #ffbf28; */
    /* margin-left: 3px; */
    /* margin-top: 3px; */
    border-radius: 50%;
    position: relative;
  }

  .normal {
    width: var(--inner-width);
    height: var(--inner-height);
    position: absolute;
    left: 0px;
    top: 0px;
    //-webkit-app-region: no-drag;
    &:hover {
      .btn {
        opacity: 1;
      }
    }
  }

  .sky {
    transform: rotate(30deg);
    position: relative;
    width: 100%;
    height: 100%;
    overflow: hidden;
    border-radius: 50%;
  }

  .line {
    position: absolute;
    animation: shooting 3s infinite ease;
    z-index: 2;
    border-radius: 1px;
    width: 2px;
    background: linear-gradient(180deg, #ffbf28 0%, rgba(255, 191, 40, 0) 100%);
  }

  .line-type-1 {
    height: 17px;
  }

  .line-type-2 {
    height: 12px;
  }

  .line-1 {
    top: 10px;
    left: 12px;
    animation-delay: calc(-13s / 1);
  }

  .line-2 {
    top: 49px;
    left: 51px;
    animation-delay: calc(-13s / 2);
  }

  .line-3 {
    top: 33px;
    left: 58px;
    animation-delay: calc(-13s / 5);
  }

  .line-4 {
    top: 0px;
    left: 43px;
    animation-delay: calc(-13s / 4);
  }

  .line-5 {
    top: 36px;
    left: 22px;
    animation-delay: calc(-13s / 3);
  }

  .line-6 {
    top: 50px;
    left: 28px;
    animation-delay: calc(-13s / 6);
  }

  .line-7 {
    top: 60px;
    left: 17px;
    animation-delay: calc(-13s / 8);
  }

  .line-8 {
    top: 41px;
    left: 43px;
    animation-delay: calc(-13s / 7);
  }

  @keyframes shooting {
    0% {
      opacity: 0;
      transform: translateY(-60px);
    }
    50% {
      opacity: 1;
    }
    100% {
      opacity: 0;
      transform: translateY(68px);
    }
  }

  .rocket {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    /* transform: scale(0.9); */
    transform: rotate(-38deg);
    position: relative;
    z-index: 3;

    img {
      width: 35px;
      height: 35px;
    }
  }

  .btn {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.8);
    display: flex;
    align-items: center;
    justify-content: center;
    color: #ddd;
    border-radius: 50%;
    font-size: 13px;
    opacity: 0;
    transition: all 0.3s;
  }

  .percent {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: #ddd;
    height: 68px;
  }

  .status {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: #ddd;
    width: var(--inner-width);
    height: var(--inner-height);
    position: absolute;
    left: 5px;
    top: 5px;
  }

  .down-title {
    line-height: 1;
    font-family: Impact;
    font-size: 16px;
    color: #ffe297;
  }

  .down-des {
    line-height: 1;
    font-size: 12px;
    margin-top: 5px;
    transform: scale(0.95);
  }

  .starting {
    font-size: 12px;
  }

  .progress {
    width: var(--inner-width);
    height: var(--inner-height);
    position: absolute;
    left: 0;
    top: 0;

    &.loading {
      .ant-progress-inner .ant-progress-circle {
        animation: loading 1s linear infinite;
      }
    }
  }
`

const StyledHome = styled.div`
  //-webkit-app-region: drag;
  user-select: none;
`

export default hot(observer(Home))
